import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-233">
      <button className="flex w-full items-center justify-between py-4 text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-234">
        <span className="text-lg font-medium text-gray-900" data-id="element-235">{question}</span>
        {isOpen ? <ChevronUp className="h-5 w-5 text-[#F59E0B]" data-id="element-236" /> : <ChevronDown className="h-5 w-5 text-gray-500" data-id="element-237" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-48 opacity-100 pb-4' : 'max-h-0 opacity-0'}`} data-id="element-238">
        <p className="text-gray-600" data-id="element-239">{answer}</p>
      </div>
    </div>;
}
export function FAQ() {
  const faqs = [{
    question: '¿Los diseños tienen marca de agua?',
    answer: 'No. Todos los archivos están limpios, en alta calidad y listos para uso comercial.'
  }, {
    question: '¿Tiene garantía?',
    answer: 'Sí. Tenés 7 días de garantía de satisfacción para comprar tranquilo usando Mercado Pago.'
  }, {
    question: '¿El acceso es inmediato?',
    answer: 'Sí. Una vez completada la compra, accedés al contenido al instante.'
  }, {
    question: '¿Puedo usar los diseños para vender mis productos?',
    answer: 'Sí. Podés cortar y vender los productos que hagas con los diseños sin problema.'
  }];
  return <div className="w-full max-w-3xl mx-auto bg-white rounded-xl shadow-sm border border-gray-100 p-6 md:p-8" data-id="element-240">
      {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-241" />)}
    </div>;
}